import angular from 'angular';

import routing from './home.routes';
import HomeController from './home.controller';

import User from '../../models/user';
import Account from '../../models/account';
import CaseMap from '../../models/case-map';
import Case from '../../models/case';
import FactQueryModel from '../../models/fact-query';
import Fact from '../../models/fact';
import FactListModel from '../../models/fact-list';
import Groupings from '../../groupings';

import IssuesModal from '../../modals/issues';
import SourcesModal from '../../modals/sources';
import TagsModal from '../../modals/tags';
import ContributorsModal from '../../modals/contributors';
import DeleteFactModal from '../../modals/delete-fact';
import FactModal from '../../modals/fact';
import ArchiveCaseModal from '../../modals/archive-case';

import ExportServ from '../../services/export';

import lfCaseList from '../../directives/lf-case-list';
import lfFilterList from '../../directives/lf-filter-list';
import lwCounter from '../../directives/lw-counter';
import adminNav from '../../directives/admin-nav';
import caseEnable from '../../directives/case-enable';
import fbEditable from '../../components/fb-editable';
import lwOnScrollEnd from '../../directives/lw-on-scroll-end';
import fbOnDelete from '../../directives/fb-on-delete';
import PaymentEnable from '../../directives/payment-enable';
import StatusNav from '../../directives/status-message/status-nav';
import lfUpdateNotification from '../../directives/lf-update-notification';
import CaseStatus from '../../directives/case-status';
import ActionGuide from '../../directives/lf-action-guide';
import lfContributorEnable from '../../directives/lf-contributor-enable';

export default angular.module('app.home', [User, Account, CaseMap, Case,
    FactQueryModel,
    FactListModel,
    lfCaseList, lfFilterList,
    lwCounter, adminNav, caseEnable,
    fbEditable, lwOnScrollEnd,
    fbOnDelete, PaymentEnable, StatusNav,
    lfUpdateNotification,
    IssuesModal,
    SourcesModal,
    TagsModal,
    ContributorsModal,
    DeleteFactModal,
    FactModal,
    ExportServ,
    CaseStatus,
    Groupings,
    Fact,
    ActionGuide,
    lfContributorEnable,
    ArchiveCaseModal
  ])
  .config(routing)
  .controller('HomeController', HomeController)
  .name;



// WEBPACK FOOTER //
// ./project/pages/home/index.js